import { z } from "zod";

export const zipFileStatusSchema = z.enum(["NONE", "READY", "EXPIRED"]);

export const zipGenerationJobStatusSchema = z.enum(["PENDING", "IN_PROGRESS", "COMPLETE", "FAILED", "CANCELLED"]);

export const dailyLogImageZipFileResponseSchema = z.discriminatedUnion("status", [
  z.object({ status: z.literal("READY"), presigned_url: z.string() }),
  z.object({ status: z.literal("NONE"), presigned_url: z.null() }),
  z.object({ status: z.literal("EXPIRED"), presigned_url: z.null() }),
]);

export const createImageZipJobResponseSchema = z.object({
  job_id: z.string(),
});

export const imageZipJobResponseSchema = z.object({
  status: zipGenerationJobStatusSchema,
  progress_rate: z.string().nullable(),
});

export const imageZipApiErrorCodeSchema = z.enum(["NO_IMAGES", "NO_JOB_FOUND", "INVALID_REQUEST"]);

export type ZipFileStatus = z.infer<typeof zipFileStatusSchema>;
export type ZipGenerationJobStatus = z.infer<typeof zipGenerationJobStatusSchema>;
export type DailyLogImageZipFileResponse = z.infer<typeof dailyLogImageZipFileResponseSchema>;
export type CreateImageZipJobResponse = z.infer<typeof createImageZipJobResponseSchema>;
export type ImageZipJobResponse = z.infer<typeof imageZipJobResponseSchema>;
export type ImageZipApiErrorCode = z.infer<typeof imageZipApiErrorCodeSchema>;

export const getImageZipProcessRateNumber = (processRate: string | null): number | null => {
  if (processRate === null) return null;
  const parsed = Number(processRate);
  return Number.isFinite(parsed) ? parsed : null;
};
